import React from 'react';

export const Stipend = () => {
  return (
    <>
      Stipend page
    </>
  )
}